/* Moments Etched v15.3.6 — Premium Personalization Studio + visual placement selector */
(() => {
  const initRoot = (root) => {
    if (!root || root.dataset.meStudioInit === '1531') return;
    root.dataset.meStudioInit = '1531';
    root.classList.remove('me-guided-v15');
    root.classList.add('me-studio-v152');

    /* Remove any prior guided UI if a cached/older asset ran first. */
    root.querySelectorAll('.me-guided-progress,.me-guided-nav,.me-guided-stage-head,.me-guided-finish-head,.me-guided-finish-back').forEach(el => el.remove());

    const steps = [
      ['Garment', 'Color'],
      ['Placement', 'Print locations'],
      ['Artwork', 'Files & details'],
      ['Quantity & Sizes', 'Order quantities'],
      ['Review & Authorize', 'Review, terms & approval']
    ];
    const titles = {
      1: ['Choose your garment color', 'Select the color for this project. Your garment preview updates automatically.'],
      2: ['Choose your print locations', 'Choose one included front placement, then add any optional back, sleeve, or neck-label printing. Artwork is positioned automatically using Moments Etched production guides.'],
      3: ['Add your artwork', 'Upload or assign the artwork and personalization details for each selected print location.'],
      4: ['Quantity & sizes', 'Enter the quantity you need for each size. Pricing and group savings update as you go.'],
      5: ['Review & authorize', 'Compare the final preview with your order details, then complete the required authorization.']
    };

    const help = root.querySelector('.me-designer-a11y-help');
    if (help && !help.querySelector('[data-me-a11y-help-close]')) {
      const closeHelp = document.createElement('button');
      closeHelp.type = 'button';
      closeHelp.className = 'me-designer-a11y-help__close';
      closeHelp.dataset.meA11yHelpClose = '';
      closeHelp.textContent = 'Close accessibility help';
      help.querySelector('.me-designer-a11y-help__content')?.appendChild(closeHelp);
      closeHelp.addEventListener('click', () => {
        help.open = false;
        help.querySelector('summary')?.focus();
      });
    }
    const progress = document.createElement('nav');
    progress.className = 'me-studio-progress';
    progress.setAttribute('aria-label', 'Personalization progress');
    steps.forEach(([label], i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'me-studio-progress__step';
      b.dataset.meStudioJump = String(i + 1);
      b.innerHTML = `<span class="me-studio-progress__num">${i + 1}</span><span class="me-studio-progress__label">${label}</span>`;
      progress.appendChild(b);
      if (i < steps.length - 1) {
        const line = document.createElement('span');
        line.className = 'me-studio-progress__line';
        line.setAttribute('aria-hidden', 'true');
        progress.appendChild(line);
      }
    });
    help?.insertAdjacentElement('afterend', progress);

    const previewToolbar = root.querySelector('.me-designer__preview-toolbar');
    let previewTabs = root.querySelector('.me-studio-preview-tabs');
    if (previewToolbar && !previewTabs) {
      previewTabs = document.createElement('div');
      previewTabs.className = 'me-studio-preview-tabs';
      previewTabs.setAttribute('aria-label', 'Preview selected print locations');
      previewToolbar.insertAdjacentElement('afterend', previewTabs);
    }

    /* Persistent preview guidance: mockup = assignment feedback, production = calibrated placement. */
    let previewGuidance = root.querySelector('.me-studio-preview-guidance');
    if (previewToolbar && !previewGuidance) {
      previewGuidance = document.createElement('aside');
      previewGuidance.className = 'me-studio-preview-guidance';
      previewGuidance.innerHTML = '<div><strong>How to read this preview</strong><span>The preview shows which artwork is assigned to each print location. Final placement follows Moments Etched production guides and laser-assisted alignment on the press.</span></div><button type="button" data-me-placement-guide-open>View placement guide</button>';
      (previewTabs || previewToolbar).insertAdjacentElement('afterend', previewGuidance);

      const guide = document.createElement('dialog');
      guide.className = 'me-studio-placement-guide';
      guide.innerHTML = '<div class="me-studio-placement-guide__card"><button type="button" class="me-studio-placement-guide__close" data-me-placement-guide-close aria-label="Close placement guide">×</button><p class="me-studio-placement-guide__eyebrow">Moments Etched production standard</p><h3>How apparel placement is determined</h3><p>Your on-screen preview is a visual confirmation of the artwork assigned to each location. It is not intended to represent exact final positioning down to the fraction of an inch.</p><div class="me-studio-placement-guide__steps"><div><strong>1. Production guide</strong><span>Each garment style uses a calibrated placement area for chest, back, sleeve, and neck-label printing.</span></div><div><strong>2. Garment-specific check</strong><span>We account for garment size, seams, collars, pockets, and construction before pressing.</span></div><div><strong>3. Laser-assisted alignment</strong><span>Our press alignment guides help us consistently center and position transfers within the approved production area.</span></div><div><strong>4. Human review</strong><span>Artwork and placement are reviewed before production, and small adjustments may be made when needed for the garment.</span></div></div><p class="me-studio-placement-guide__note">The placement boundary in the Studio is therefore a production guide—not a customer-controlled drag-and-drop area.</p></div>';
      root.appendChild(guide);
      const openGuide = previewGuidance.querySelector('[data-me-placement-guide-open]');
      const closeGuide = guide.querySelector('[data-me-placement-guide-close]');
      openGuide?.addEventListener('click', () => { if (typeof guide.showModal === 'function') guide.showModal(); else guide.setAttribute('open',''); });
      closeGuide?.addEventListener('click', () => guide.close?.());
      guide.addEventListener('click', (event) => { if (event.target === guide) guide.close?.(); });
    }

    const designPanel = root.querySelector('[data-me-step-panel="design"]');
    const artworkPanel = root.querySelector('[data-me-step-panel="artwork"]');
    const reviewPanel = root.querySelector('[data-me-step-panel="review"]');
    const controls = root.querySelector('.me-designer__controls');
    const sidebar = root.querySelector('.me-designer__sidebar');
    const reviewPurchase = root.querySelector('[data-me-review-purchase]');
    const actionFooter = root.querySelector('.me-builder2__action-footer');
    const nativePrimary = root.querySelector('[data-me-designer-primary-action]');
    const rightsCheckbox = root.querySelector('[data-me-rights-checkbox]');
    const authorizationCard = root.querySelector('[data-me-authorization-card]');
    const authorizationLegal = root.querySelector('.me-sidebar-approval__legal');
    const sidebarApproval = root.querySelector('[data-me-sidebar-approval]');
    const multiSizeNote = root.querySelector('[data-me-multi-size-cart-note]');
    const volumePricing = root.querySelector('[data-me-volume-pricing]');

    /* Artwork authorization belongs with the artwork itself, not hidden at checkout. */
    let artworkAuthorization = artworkPanel?.querySelector('.me-studio-artwork-authorization');
    if (artworkPanel && authorizationCard && !artworkAuthorization) {
      artworkAuthorization = document.createElement('section');
      artworkAuthorization.className = 'me-studio-artwork-authorization';
      artworkAuthorization.innerHTML = '<div class="me-studio-artwork-authorization__heading"><span data-me-artwork-auth-status>Required</span><strong>Artwork authorization</strong><p>Confirm that you have permission to reproduce the artwork before continuing.</p></div>';
      const artworkStudio = artworkPanel.querySelector('.me-personalization-studio--artwork');
      const firstSection = artworkStudio?.querySelector(':scope > .me-control-section');
      if (artworkStudio && firstSection) artworkStudio.insertBefore(artworkAuthorization, firstSection);
      else artworkPanel.appendChild(artworkAuthorization);
      artworkAuthorization.appendChild(authorizationCard);
      if (authorizationLegal) authorizationLegal.hidden = true;
    }

    if (multiSizeNote) multiSizeNote.hidden = true;
    const nativeStep = (name) => root.querySelector(`[data-me-step-button="${name}"]`);

    /* Size controls use the existing proven commerce logic, but live only in Stage 4. */
    const orderType = designPanel?.querySelector('[data-me-order-type]');
    const sizeSetup = designPanel?.querySelector('.me-size-distribution--setup[data-me-size-distribution]');
    const singleSizePanel = designPanel?.querySelector('[data-me-single-size-panel]');
    const reviewScroll = reviewPanel?.querySelector('.me-designer-panel__review-scroll');
    let sizeStage = reviewPanel?.querySelector('.me-studio-size-stage');
    if (reviewScroll && !sizeStage) {
      sizeStage = document.createElement('div');
      sizeStage.className = 'me-studio-size-stage';
      const reviewStudio = reviewScroll.querySelector('.me-personalization-studio--review');
      const reviewAnchor = reviewStudio?.closest('.me-stage5-written-review') || reviewStudio;
      reviewScroll.insertBefore(sizeStage, reviewAnchor || null);
      if (sizeSetup) sizeStage.appendChild(sizeSetup);
      const distribution = reviewPanel.querySelector('.me-size-distribution--review[data-me-size-distribution]');
      if (distribution) sizeStage.appendChild(distribution);
      const pricing = document.createElement('div');
      pricing.className = 'me-studio-qty-pricing';
      pricing.innerHTML = '<div><span>Total pieces</span><strong data-me-studio-qty>0</strong></div><div><span>Current unit price</span><strong data-me-studio-unit>$0.00</strong><small data-me-studio-unit-detail></small></div><div><span>Estimated total</span><strong data-me-studio-total>$0.00</strong></div><p data-me-studio-savings>Group savings begin at 10 pieces.</p>';
      const distributionForPricing = sizeStage.querySelector('.me-size-distribution--review[data-me-size-distribution]');
      if (distributionForPricing) sizeStage.insertBefore(pricing, distributionForPricing);
      else sizeStage.appendChild(pricing);
    }

    /* Make Review & Finish one customer-facing task panel instead of a separate sidebar screen. */
    if (reviewScroll && reviewPurchase && reviewPurchase.parentElement !== reviewScroll) reviewScroll.appendChild(reviewPurchase);
    if (reviewPanel && actionFooter && actionFooter.parentElement !== reviewPanel) reviewPanel.appendChild(actionFooter);
    sidebar?.setAttribute('aria-hidden', 'true');

    if (reviewPurchase && !reviewPurchase.querySelector('.me-studio-proof-banner')) {
      const banner = document.createElement('div');
      banner.className = 'me-studio-proof-banner';
      banner.innerHTML = '<strong>Digital proof by email</strong><span>Receive a mockup showing your artwork on the selected garment and print locations before production.</span><em class="me-studio-proof-delay">Production waits for your approval. Delayed approval may delay your order.</em>';
      reviewPurchase.prepend(banner);
      if (sidebarApproval) banner.insertAdjacentElement('afterend', sidebarApproval);
      if (volumePricing && sidebarApproval) sidebarApproval.insertAdjacentElement('afterend', volumePricing);
      if (multiSizeNote) multiSizeNote.hidden = true;
    }


    /* v15.4.4.4 — allow quantities to be adjusted from Review & Finish without forcing a back-step. */
    let stage5QtyToggle = reviewPurchase?.querySelector('[data-me-stage5-qty-toggle]');
    if (reviewPurchase && volumePricing && !stage5QtyToggle) {
      stage5QtyToggle = document.createElement('button');
      stage5QtyToggle.type = 'button';
      stage5QtyToggle.className = 'me-stage5-qty-toggle';
      stage5QtyToggle.dataset.meStage5QtyToggle = '';
      stage5QtyToggle.setAttribute('aria-expanded', 'false');
      stage5QtyToggle.innerHTML = '<span><strong>Quantity & sizes</strong><small>Adjust quantities here without leaving Review & Finish.</small></span><span aria-hidden="true">Edit</span>';
      volumePricing.prepend(stage5QtyToggle);
      stage5QtyToggle.addEventListener('click', () => {
        const open = !root.classList.contains('me-stage5-edit-qty');
        root.classList.toggle('me-stage5-edit-qty', open);
        stage5QtyToggle.setAttribute('aria-expanded', String(open));
        stage5QtyToggle.lastElementChild.textContent = open ? 'Done' : 'Edit';
        if (open) window.setTimeout(() => {
          sizeStage?.querySelector('[data-me-size-quantity],button')?.focus({preventScroll:true});
          sizeStage?.scrollIntoView({behavior:'smooth', block:'nearest'});
        }, 30);
      });
    }

    /* v15.4.6.7 — give Review & Finish an explicit Back action beside the final cart action.
       Keep this separate from the main Studio nav so Step 5 retains its compact review layout. */
    let stage5BackButton = actionFooter?.querySelector('[data-me-stage5-back]');
    if (actionFooter && nativePrimary && !stage5BackButton) {
      stage5BackButton = document.createElement('button');
      stage5BackButton.type = 'button';
      stage5BackButton.className = 'me-stage5-back';
      stage5BackButton.dataset.meStage5Back = '';
      stage5BackButton.textContent = '← Back';
      nativePrimary.insertAdjacentElement('beforebegin', stage5BackButton);
      stage5BackButton.addEventListener('click', () => {
        root.classList.remove('me-stage5-edit-qty');
        if (stage5QtyToggle) {
          stage5QtyToggle.setAttribute('aria-expanded', 'false');
          if (stage5QtyToggle.lastElementChild) stage5QtyToggle.lastElementChild.textContent = 'Edit';
        }
        go(4);
      });
    }

    /* v15.4.7.31 — keep the Step 5 action row anchored. Cart progress/error
       text used to live inside the sticky action footer, so adding a project
       increased the footer height and covered the Estimated total project row.
       Keep status in the review content instead, directly after the total. */
    const stage5CartStatus = root.querySelector('[data-me-designer-cart-status]');
    const stage5ProjectTotal = reviewPurchase?.querySelector('.me-designer__sidebar-total');
    if (stage5CartStatus && stage5ProjectTotal && !stage5CartStatus.closest('[data-me-review-purchase]')) {
      stage5CartStatus.classList.add('me-stage5-cart-status');
      stage5ProjectTotal.insertAdjacentElement('afterend', stage5CartStatus);
    }

    /* Remove internal production packet blocks from the customer-facing review. */
    reviewPanel?.querySelectorAll('.me-production-packet,.me-review-production-packet,[data-me-production-packet],.me-production-ready-summary').forEach(el => el.classList.add('me-studio-internal-only'));

    const nav = document.createElement('div');
    nav.className = 'me-studio-nav';
    nav.innerHTML = '<button type="button" class="me-studio-nav__back" data-me-studio-back>← Back</button><span class="me-studio-nav__status" data-me-studio-status></span><button type="button" class="me-studio-nav__next" data-me-studio-next>Continue →</button>';
    controls?.appendChild(nav);

    const back = nav.querySelector('[data-me-studio-back]');
    const next = nav.querySelector('[data-me-studio-next]');
    const status = nav.querySelector('[data-me-studio-status]');
    let stage = 1;
    let allowNativePrimary = false;
    const CUSTOM_APPAREL_QUOTE_MIN = 21;
    const getStudioQuantity = () => [...root.querySelectorAll('[data-me-size-quantity]')].reduce((sum, input) => sum + Math.max(0, parseInt(input.value || '0', 10) || 0), 0);
    const isQuoteRequired = () => getStudioQuantity() >= CUSTOM_APPAREL_QUOTE_MIN;
    const openBulkQuote = () => {
      const opener = root.querySelector('[data-me-volume-bulk-cta] [data-me-quote-open], [data-me-quote-header], [data-me-quote-open]');
      opener?.click?.();
    };

    const setCoreStep = (name) => {
      const btn = nativeStep(name);
      if (!btn) return;

      // v15.4.7.20 — cart re-edit hydration can finish asynchronously after the
      // customer has already moved through the five-stage Studio. In that case
      // the legacy 3-step engine may report the expected step in its dataset while
      // its panel hidden/active state is stale. Treat the DOM panel state as part
      // of the source of truth and re-run the native step when either disagrees.
      const panels = [designPanel, artworkPanel, reviewPanel].filter(Boolean);
      const targetPanel = panels.find((panel) => panel.dataset.meStepPanel === name);
      const panelStateMismatch = Boolean(targetPanel) && (
        targetPanel.hidden ||
        !targetPanel.classList.contains('is-active') ||
        panels.some((panel) => panel !== targetPanel && (!panel.hidden || panel.classList.contains('is-active')))
      );

      if (root.dataset.meCurrentStep !== name || panelStateMismatch) btn.click();
    };

    const headingFor = (panel, n) => {
      if (!panel) return;
      let h = panel.querySelector(':scope > .me-studio-stage-head');

      // Stage 5 already has the persistent progress step plus the custom
      // “Review & authorize your custom order” agreement heading. A third
      // legacy “Step 5 of 5 / Review & authorize” heading caused text to
      // peek through the compact review layout while scrolling.
      if (n === 5) {
        h?.remove();
        return;
      }

      if (!h) {
        h = document.createElement('header');
        h.className = 'me-studio-stage-head';
        panel.prepend(h);
      }
      const [title, desc] = titles[n];
      h.innerHTML = `<p class="me-studio-stage-head__eyebrow">Step ${n} of 5</p><h3 tabindex="-1" data-me-studio-focus>${title}</h3><p>${desc}</p>`;
    };

    const focusStage = () => window.setTimeout(() => {
      const target = root.querySelector('[data-me-studio-focus]')
        || (stage === 5 ? root.querySelector('[data-me-custom-agreement] h4') : null);
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target?.focus?.({preventScroll:false});
    }, 50);

    const isCartArtworkRestoring = () => root.dataset.meEditRestorePending === 'true';
    const ensureArtworkRestoreNotice = () => {
      if (!artworkPanel) return null;
      let notice = artworkPanel.querySelector('[data-me-artwork-restore-notice]');
      if (notice) return notice;
      notice = document.createElement('div');
      notice.className = 'me-studio-artwork-restore';
      notice.dataset.meArtworkRestoreNotice = '';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.setAttribute('aria-atomic', 'true');
      notice.innerHTML = '<span class="me-studio-artwork-restore__spinner" aria-hidden="true"></span><span><strong>Restoring your saved artwork…</strong><small>Your uploaded files are being reattached to this project.</small></span>';
      const artworkStudio = artworkPanel.querySelector('.me-personalization-studio--artwork');
      if (artworkStudio) artworkStudio.prepend(notice);
      else artworkPanel.appendChild(notice);
      return notice;
    };
    const syncArtworkRestoreState = () => {
      const restoring = isCartArtworkRestoring();
      const notice = ensureArtworkRestoreNotice();
      if (notice) notice.hidden = !restoring;
      artworkPanel?.setAttribute('aria-busy', restoring ? 'true' : 'false');
      if (next && stage === 3) {
        next.disabled = restoring;
        next.setAttribute('aria-disabled', String(restoring));
        next.textContent = restoring ? 'Restoring project…' : 'Continue to Quantity & Sizes →';
      } else if (next && !restoring) {
        next.disabled = false;
        next.removeAttribute('aria-disabled');
      }
      if (restoring) hidePreflightBlockedAlert?.();
    };

    const syncPrimary = () => {
      if (!nativePrimary) return;
      const label = nativePrimary.querySelector('[data-me-primary-action-label]');
      if (stage === 5 && label) {
        label.textContent = isQuoteRequired()
          ? 'Request Bulk Quote'
          : (root.dataset.meEditingCartProject === 'true' ? 'Confirm & Update Item' : 'Confirm & Add to Cart');
      }
      nativePrimary.classList.toggle('me-studio-quote-required-action', stage === 5 && isQuoteRequired());
    };

    const money = cents => new Intl.NumberFormat(undefined, { style:'currency', currency:'USD' }).format((Number(cents)||0)/100);
    const currentProduct = () => window.MomentsCurrentProduct || (() => {
      try { return JSON.parse(root.querySelector('[data-me-initial-product-json]')?.textContent || 'null'); } catch (_) { return null; }
    })();
    const normalizeSize = value => String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
    const getSelectedPlacementPricing = () => {
      const placements = [...root.querySelectorAll('[data-me-placement-checkbox]:checked')]
        .map(input => input.value)
        .filter(Boolean);
      const placementRules = window.MEPlacementRules?.placements || {};
      const paidPlacements = placements
        .map((placement) => ({
          placement,
          priceCents: Math.max(0, Number(placementRules?.[placement]?.priceCents || 0))
        }))
        .filter(item => item.priceCents > 0);
      return {
        placements,
        paidPlacements,
        addOnPerGarment: paidPlacements.reduce((sum, item) => sum + item.priceCents, 0)
      };
    };
    const getInsideBrandingPricing = () => {
      const neckMode = String(root.dataset.meNeckLabelMode || root.querySelector('[data-me-neck-label-choice]:checked')?.value || 'original');
      const brandingCreditPerGarment = neckMode === 'me-branding'
        ? Math.max(0, Number(root.dataset.meBrandingCreditCents || 200))
        : 0;
      return { neckMode, brandingCreditPerGarment };
    };
    const enrichSizeRows = () => {
      const product = currentProduct();
      if (!product?.variants) return;
      const { addOnPerGarment } = getSelectedPlacementPricing();
      const { brandingCreditPerGarment } = getInsideBrandingPricing();
      root.querySelectorAll('[data-me-distribution-row]').forEach(row => {
        const input = row.querySelector('[data-me-size-quantity]');
        if (!input) return;
        const size = normalizeSize(input.dataset.meSizeValue);
        const variant = product.variants.find(v => (v.options || []).some(o => normalizeSize(o) === size)) || product.variants.find(v => normalizeSize(v.title) === size);
        let price = row.querySelector('.me-studio-size-price');
        if (!price) { price = document.createElement('small'); price.className='me-studio-size-price'; row.appendChild(price); }
        price.textContent = variant?.price != null
          ? `${money(Math.max(0, Number(variant.price || 0) + addOnPerGarment - brandingCreditPerGarment))} ea. configured`
          : '';
      });
    };
    const syncQtyPricing = () => {
      if (!sizeStage) return;

      const product = currentProduct();
      const rows = [...root.querySelectorAll('[data-me-size-quantity]')].map((input) => {
        const quantity = Math.max(0, parseInt(input.value || '0', 10) || 0);
        const size = normalizeSize(input.dataset.meSizeValue || '');
        const variant = product?.variants?.find(v => (v.options || []).some(o => normalizeSize(o) === size))
          || product?.variants?.find(v => normalizeSize(v.title) === size);
        return { input, quantity, size, variant, price: Number(variant?.price || 0) };
      }).filter(row => row.quantity > 0);

      const qty = rows.reduce((sum, row) => sum + row.quantity, 0);
      const garmentSubtotal = rows.reduce((sum, row) => sum + (row.price * row.quantity), 0);
      const { paidPlacements, addOnPerGarment } = getSelectedPlacementPricing();
      const addOnSubtotal = addOnPerGarment * qty;
      const { neckMode, brandingCreditPerGarment } = getInsideBrandingPricing();
      const brandingCredit = brandingCreditPerGarment * qty;
      const tierRate = qty >= CUSTOM_APPAREL_QUOTE_MIN ? 0 : qty >= 11 ? 0.10 : qty >= 6 ? 0.05 : 0;
      // v15.4.7.28: the ME branding credit is a product discount and the
      // group tier is an order discount. Shopify now combines them. Apply the
      // $2/garment branding credit first, then calculate the group percentage
      // only on the remaining garment merchandise. Paid print add-ons remain
      // full price and are excluded from the group-savings base.
      const discountedGarmentSubtotal = Math.max(0, garmentSubtotal - brandingCredit);
      const groupSavings = tierRate > 0
        ? Math.floor(discountedGarmentSubtotal * tierRate)
        : 0;
      const effectiveSavings = brandingCredit + groupSavings;
      const estimatedTotal = Math.max(0, garmentSubtotal + addOnSubtotal - effectiveSavings);

      const qtyNode = sizeStage.querySelector('[data-me-studio-qty]');
      const unitNode = sizeStage.querySelector('[data-me-studio-unit]');
      const unitDetailNode = sizeStage.querySelector('[data-me-studio-unit-detail]');
      const totalNode = sizeStage.querySelector('[data-me-studio-total]');
      const savingsNode = sizeStage.querySelector('[data-me-studio-savings]');
      if (qtyNode) qtyNode.textContent = String(qty);
      if (unitNode) {
        const configuredBase = Number(root.dataset.meBasePriceCents || 0);
        const configuredBeforeSavings = Math.max(0, configuredBase + addOnPerGarment);
        // The Moments Etched inside-neck option is a real $2/garment credit, so
        // the zero-quantity configured price must show it immediately instead of
        // waiting for the customer to enter a size quantity.
        const configuredAfterBrandingCredit = Math.max(0, configuredBeforeSavings - brandingCreditPerGarment);
        const currentEffectiveUnit = qty > 0 ? Math.round(estimatedTotal / qty) : configuredAfterBrandingCredit;
        unitNode.textContent = rows.length > 1 && qty > 0
          ? `Avg. ${money(currentEffectiveUnit)}`
          : money(currentEffectiveUnit);
        if (unitDetailNode) {
          if (qty > 0 && effectiveSavings > 0) {
            unitDetailNode.textContent = 'Includes selected print add-ons and current savings.';
          } else if (addOnPerGarment > 0 || brandingCreditPerGarment > 0) {
            const addOnCopy = addOnPerGarment > 0 ? ` + ${money(addOnPerGarment)} print add-ons` : '';
            const creditCopy = brandingCreditPerGarment > 0 ? ` − ${money(brandingCreditPerGarment)} ME branding credit` : '';
            unitDetailNode.textContent = `${money(configuredBase)} garment${addOnCopy}${creditCopy}.`;
          } else {
            unitDetailNode.textContent = 'Configured garment price.';
          }
        }
      }
      if (totalNode) totalNode.textContent = money(estimatedTotal);
      /* Keep Review & Finish aligned with the actual Step 4 project estimate. */
      root.querySelectorAll('[data-me-price-total],[data-me-review-total],[data-me-project-total]').forEach(node => {
        node.textContent = money(estimatedTotal);
      });
      root.dataset.meEstimatedProjectTotalCents = String(estimatedTotal);

      let breakdown = sizeStage.querySelector('[data-me-studio-price-breakdown]');
      if (!breakdown) {
        breakdown = document.createElement('div');
        breakdown.className = 'me-studio-price-breakdown';
        breakdown.dataset.meStudioPriceBreakdown = '';
        const pricing = sizeStage.querySelector('.me-studio-qty-pricing');
        pricing?.appendChild(breakdown);
      }
      if (breakdown) {
        const creditRow = brandingCredit > 0
          ? `<div class="me-studio-price-breakdown__row is-credit"><span>Moments Etched branding credit <small>${qty} × ${money(brandingCreditPerGarment)} · applied</small></span><strong>−${money(brandingCredit)}</strong></div>`
          : '';
        const savingsRow = groupSavings > 0
          ? `<div class="me-studio-price-breakdown__row is-savings"><span>${Math.round(tierRate * 100)}% group savings <small>applied after branding credit</small></span><strong>−${money(groupSavings)}</strong></div>`
          : '';
        breakdown.innerHTML = `
          <div class="me-studio-price-breakdown__row"><span>Garments</span><strong>${money(garmentSubtotal)}</strong></div>
          ${addOnSubtotal > 0 ? `<div class="me-studio-price-breakdown__row"><span>Print add-ons <small>${paidPlacements.map(item => `${escapePreflightText(item.placement)} ${money(item.priceCents)}`).join(' · ')}</small></span><strong>+${money(addOnSubtotal)}</strong></div>` : ''}
          ${creditRow}
          ${savingsRow}
          <div class="me-studio-price-breakdown__row is-total"><span>${qty >= CUSTOM_APPAREL_QUOTE_MIN ? 'Current project estimate' : 'Estimated checkout total'}</span><strong>${money(estimatedTotal)}</strong></div>`;
      }

      if (savingsNode) {
        savingsNode.textContent = qty >= CUSTOM_APPAREL_QUOTE_MIN
          ? '21+ bulk pricing available. Submit a quote request for final pricing based on your order details.'
          : qty >= 11
            ? '10% group savings tier reached. Orders of 21+ use custom bulk pricing.'
            : qty >= 6
              ? '5% group savings tier reached.'
              : `Add ${Math.max(0,6-qty)} more ${6-qty===1?'piece':'pieces'} to unlock the 5% group savings tier.`;
        savingsNode.classList.toggle('is-savings-active', qty >= 6 && qty < CUSTOM_APPAREL_QUOTE_MIN);
        savingsNode.classList.toggle('is-quote-required', qty >= CUSTOM_APPAREL_QUOTE_MIN);
      }
      root.classList.toggle('me-studio-quote-required', qty >= CUSTOM_APPAREL_QUOTE_MIN);
      root.dataset.meCustomApparelQuoteRequired = qty >= CUSTOM_APPAREL_QUOTE_MIN ? 'true' : 'false';
      if (stage === 4 && next) next.textContent = qty >= CUSTOM_APPAREL_QUOTE_MIN ? 'Continue to Review & Quote →' : 'Continue to Review & Authorize →';
      syncPrimary();
      enrichSizeRows();
    };
    const ensureUnifiedQuantityMode = () => {
      const multi = root.querySelector('[data-me-order-mode="multi"]');
      if (!multi) return;
      const active = multi.classList.contains('is-active') || multi.getAttribute('aria-pressed') === 'true';
      if (!active) multi.click();
      window.setTimeout(() => { window.MomentsProject?.hydrateDistribution?.(true); enrichSizeRows(); syncQtyPricing(); }, 20);
    };
    const syncPreviewTabs = () => {
      if (!previewTabs) return;
      const placements = [...root.querySelectorAll('[data-me-placement-checkbox]:checked')].map(i => i.value).filter(Boolean);
      const neckMode = String(root.dataset.meNeckLabelMode || root.querySelector('[data-me-neck-label-choice]:checked')?.value || 'original');
      if (neckMode === 'me-branding' || neckMode === 'custom') placements.push('Custom Neck Label');
      const uniquePlacements = [...new Set(placements)];
      previewTabs.replaceChildren();
      uniquePlacements.forEach(placement => {
        const b=document.createElement('button'); b.type='button'; b.textContent=placement; b.dataset.mePreviewPlacement=placement;
        b.addEventListener('click', () => {
          const artworkCard = root.querySelector(`[data-me-location-artwork="${CSS.escape(placement)}"]`);
          if (artworkCard) {
            // Let the artwork controller reactivate the saved assignment. It dispatches
            // me:preview-placement with the existing object URL; do not overwrite it
            // with an empty URL afterward.
            const topline = artworkCard.querySelector('.me-location-artwork__topline');
            if (topline) topline.click();
            else artworkCard.click();
          } else {
            // Moments Etched branding has no customer artwork card, but still needs
            // a selectable neck-label template preview.
            window.dispatchEvent(new CustomEvent('me:preview-placement', { detail: { placement, artworkUrl: '' } }));
          }
        });
        previewTabs.appendChild(b);
      });
      previewTabs.hidden = uniquePlacements.length < 2;

      /* v15.4.5.4 — keep the live preview on a placement that is actually selected.
         Previously the preview controller booted on Left Chest even when the included
         front placement had been changed to Full Front/Center/Right. That made valid
         calibration values look wrong because the boundary was still using the stale
         Left Chest profile. If the current preview is no longer one of the selected
         locations, activate the first real selected location through the existing tab
         click path so saved artwork/object URLs are retained. */
      const currentPreviewPlacement = String(
        root.querySelector('[data-me-preview-placement-label]')?.textContent || ''
      ).trim();
      if (uniquePlacements.length && !uniquePlacements.includes(currentPreviewPlacement)) {
        const firstPreviewTab = previewTabs.querySelector('[data-me-preview-placement]');
        window.requestAnimationFrame(() => firstPreviewTab?.click());
      }
    };

    const render = ({focus=true}={}) => {
      root.dataset.meStudioStage = String(stage);
      progress.querySelectorAll('[data-me-studio-jump]').forEach((b) => {
        const n = Number(b.dataset.meStudioJump);
        b.toggleAttribute('disabled', n > stage);
        b.removeAttribute('aria-current');
        if (n === stage) b.setAttribute('aria-current', 'step');
      });

      if (stage <= 2) {
        setCoreStep('design');
        headingFor(designPanel, stage);
      } else if (stage === 3) {
        setCoreStep('artwork');
        headingFor(artworkPanel, 3);
      } else {
        setCoreStep('review');
        headingFor(reviewPanel, stage);
      }

      back.hidden = stage === 1;
      nav.hidden = stage === 5;
      next.textContent = stage === 1 ? 'Continue to Placement →' : stage === 2 ? 'Continue to Artwork →' : stage === 3 ? 'Continue to Quantity & Sizes →' : 'Continue to Review & Authorize →';
      status.textContent = `Step ${stage} of 5 · ${steps[stage - 1][1]}`;
      syncArtworkRestoreState();
      if (reviewPurchase) reviewPurchase.hidden = stage !== 5;
      if (stage !== 5) {
        root.classList.remove('me-stage5-edit-qty');
        if (stage5QtyToggle) {
          stage5QtyToggle.setAttribute('aria-expanded', 'false');
          if (stage5QtyToggle.lastElementChild) stage5QtyToggle.lastElementChild.textContent = 'Edit';
        }
      }
      if (stage === 4) ensureUnifiedQuantityMode();
      /* Each Studio stage starts at the top; never inherit hidden legacy scroll positions. */
      try { controls.scrollTop = 0; } catch (_) {}
      try { artworkPanel?.querySelector('.me-personalization-studio--artwork')?.scrollTo?.({ top: 0, behavior: 'auto' }); } catch (_) {}
      [designPanel, artworkPanel, reviewPanel, reviewScroll].forEach(el => { try { if (el) el.scrollTop = 0; } catch (_) {} });
      if (stage === 5 && reviewScroll) window.setTimeout(() => { reviewScroll.scrollTop = 0; }, 0);
      syncPreviewTabs();
      window.setTimeout(() => { syncPrimary(); syncQtyPricing(); }, 0);
      if (focus) focusStage();
    };

    const go = (n) => {
      stage = Math.max(1, Math.min(5, n));
      if (stage !== 3) hidePreflightBlockedAlert();
      if (stage !== 4) hideQuantityBlockedAlert();
      render();
    };

    /* v15.4.7.20 — when a cart project finishes restoring, re-assert the
       five-stage Studio's current stage instead of allowing the legacy engine
       to leave a stale Design panel visible above Artwork. Preserve the stage
       the customer is already on; do not yank them back to Step 1. */
    window.addEventListener('me:edit-project-restore-state', () => {
      if (root.dataset.meEditingCartProject !== 'true') return;
      window.setTimeout(() => syncArtworkRestoreState(), 0);
    });

    window.addEventListener('me:edit-project-restored', () => {
      if (root.dataset.meEditingCartProject !== 'true') return;
      window.setTimeout(() => {
        const rememberedStage = Number(root.dataset.meStudioStage || stage || 1);
        stage = Math.max(1, Math.min(5, Number.isFinite(rememberedStage) ? rememberedStage : 1));
        render({ focus: false });
      }, 0);
    });

    const sizeMissing = () => [...root.querySelectorAll('[data-me-size-quantity]')].reduce((sum,input)=>sum + Math.max(0,parseInt(input.value||'0',10)||0),0) <= 0;

    const runNativePrimary = () => {
      if (!nativePrimary) return;
      allowNativePrimary = true;
      nativePrimary.click();
      allowNativePrimary = false;
    };

    /* =========================================================
       v15.4.7.6 — Step 3 required-state & status accuracy
       One authoritative validation state now combines:
       - missing placement customization
       - artwork quality/preflight issues
       - artwork authorization
       COMPLETE only means production-ready for this step.
       ========================================================= */
    let preflightAlertShown = false;

    const escapePreflightText = (value) => String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const getPreflightCard = (placement) => {
      if (!placement) return null;
      return root.querySelector(`[data-me-location-artwork="${CSS.escape(placement)}"]`);
    };

    const getPreflightDpi = (placement) => {
      const card = getPreflightCard(placement);
      if (!card) return null;
      for (const row of card.querySelectorAll('.me-location-artwork__quality-row')) {
        const match = String(row.textContent || '').match(/(\d+)\s+effective\s+DPI/i);
        if (match) return Number(match[1]);
      }
      return null;
    };

    const getPreflightIssueTarget = (card, type) => {
      if (!card) return null;
      if (type === 'acknowledgment') {
        return card.querySelector('[data-me-location-quality-ack-wrap]') ||
          card.querySelector('[data-me-location-quality-ack]');
      }
      if (type === 'missing') {
        return card.querySelector('.me-location-artwork__upload') ||
          card.querySelector('[data-me-location-input]') ||
          card;
      }
      return card.querySelector('.me-location-artwork__summary.is-error') ||
        card.querySelector('.me-location-artwork__summary') ||
        card;
    };

    const getArtworkScrollContainer = () =>
      artworkPanel?.querySelector('.me-personalization-studio--artwork') || controls;

    const artworkTargetIsVisible = (target) => {
      const scroller = getArtworkScrollContainer();
      if (!target || !scroller || !nav) return true;
      const targetRect = target.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();
      const visibleTop = scrollerRect.top + 12;
      const visibleBottom = Math.min(scrollerRect.bottom, navRect.top) - 12;
      if (visibleBottom <= visibleTop) return true;
      return targetRect.top >= visibleTop && targetRect.bottom <= visibleBottom;
    };

    const scrollArtworkElementWithinColumn = (target) => {
      const scroller = getArtworkScrollContainer();
      if (!target || !scroller || artworkTargetIsVisible(target)) return false;

      const targetRect = target.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();
      const visibleTop = scrollerRect.top + 16;
      const visibleBottom = Math.min(scrollerRect.bottom, navRect.top) - 16;
      const availableHeight = Math.max(1, visibleBottom - visibleTop);
      let delta = 0;

      if (targetRect.height >= availableHeight || targetRect.top < visibleTop) {
        delta = targetRect.top - visibleTop;
      } else if (targetRect.bottom > visibleBottom) {
        delta = targetRect.bottom - visibleBottom;
      }

      if (Math.abs(delta) < 2) return false;
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
      scroller.scrollTo({
        top: Math.max(0, scroller.scrollTop + delta),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
      return true;
    };

    const scrollArtworkTargetWithinColumn = (card, type) => {
      const target = getPreflightIssueTarget(card, type) || card;
      return scrollArtworkElementWithinColumn(target);
    };

    const syncArtworkAuthorizationState = () => {
      if (!artworkAuthorization) return;
      const confirmed = Boolean(rightsCheckbox?.checked);
      const badge = artworkAuthorization.querySelector('[data-me-artwork-auth-status]');
      artworkAuthorization.classList.toggle('is-complete', confirmed);
      artworkAuthorization.classList.toggle('is-required', !confirmed);
      if (badge) badge.textContent = confirmed ? 'Confirmed' : 'Required';
      if (authorizationCard) {
        authorizationCard.setAttribute(
          'aria-label',
          confirmed ? 'Artwork authorization confirmed' : 'Artwork authorization required'
        );
      }
    };

    const getStep3ValidationState = () => {
      const artworkState = window.MEArtworkManager?.getPreflightState?.() || { ok: true, issues: [] };
      if (isCartArtworkRestoring() || artworkState.restoring) {
        return { ok: false, restoring: true, issues: [], authorizationMissing: false, artworkIssues: [] };
      }
      const artworkIssues = Array.isArray(artworkState.issues) ? artworkState.issues : [];
      const authorizationMissing = Boolean(rightsCheckbox && !rightsCheckbox.checked);
      const issues = [];

      if (authorizationMissing) {
        issues.push({
          type: 'authorization',
          category: 'authorization',
          message: 'Artwork authorization is required before continuing.'
        });
      }

      artworkIssues.forEach((issue) => issues.push({ ...issue, category: 'artwork' }));

      return {
        ok: issues.length === 0,
        issues,
        authorizationMissing,
        artworkIssues
      };
    };

    const ensurePreflightBlockedAlert = () => {
      let alert = nav.querySelector('[data-me-preflight-blocked-alert]');
      if (alert) return alert;

      alert = document.createElement('section');
      alert.className = 'me-studio-nav__preflight';
      alert.dataset.mePreflightBlockedAlert = '';
      alert.setAttribute('role', 'alert');
      alert.setAttribute('aria-live', 'assertive');
      alert.setAttribute('aria-atomic', 'true');
      alert.tabIndex = -1;
      alert.hidden = true;
      nav.prepend(alert);
      return alert;
    };

    const hidePreflightBlockedAlert = () => {
      const alert = nav.querySelector('[data-me-preflight-blocked-alert]');
      if (alert) alert.hidden = true;
      preflightAlertShown = false;
    };

    const revealAuthorizationIssue = ({ focusIssue = false } = {}) => {
      if (!artworkAuthorization) return;
      scrollArtworkElementWithinColumn(artworkAuthorization);
      if (focusIssue && rightsCheckbox) {
        window.setTimeout(() => {
          try { rightsCheckbox.focus({ preventScroll: true }); } catch (_) { rightsCheckbox.focus(); }
        }, 40);
      }
    };

    const revealPreflightIssue = (issue, { focusIssue = false } = {}) => {
      if (!issue) return;
      if (issue.type === 'authorization') {
        revealAuthorizationIssue({ focusIssue });
        return;
      }
      if (!issue.placement) return;

      const placement = issue.placement;
      window.MEArtworkManager?.activate?.(placement);

      window.requestAnimationFrame(() => {
        const card = getPreflightCard(placement);
        if (!card) return;
        const target = getPreflightIssueTarget(card, issue.type) || card;
        scrollArtworkTargetWithinColumn(card, issue.type);

        if (focusIssue) {
          window.setTimeout(() => {
            if (issue.type === 'acknowledgment') {
              const ack = card.querySelector('[data-me-location-quality-ack]');
              if (ack) {
                try { ack.focus({ preventScroll: true }); } catch (_) { ack.focus(); }
                return;
              }
            }
            if (issue.type === 'missing') {
              const input = card.querySelector('[data-me-location-input]');
              if (input) {
                try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
                return;
              }
            }
            if (target !== card) target.tabIndex = -1;
            try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
          }, 40);
        }
      });
    };

    const artworkIssueDetail = (issue) => {
      if (!issue) return 'Artwork needs attention before you can continue.';
      const placement = escapePreflightText(issue.placement || 'Artwork');
      if (issue.type === 'missing') return `${placement} still needs artwork.`;
      if (issue.type === 'acknowledgment') return `${placement} needs your low-resolution quality acknowledgment.`;
      if (issue.type === 'blocked') {
        const dpi = getPreflightDpi(issue.placement);
        return Number.isFinite(dpi)
          ? `${placement} is <strong>${dpi} DPI</strong>; this print size requires at least <strong>150 DPI</strong>.`
          : `${placement} is below the <strong>150 DPI</strong> minimum for this print size.`;
      }
      return `${placement} needs attention before you can continue.`;
    };

    const renderPreflightBlockedAlert = (validation, { moveFocus = false } = {}) => {
      if (!validation || validation.ok) {
        hidePreflightBlockedAlert();
        return;
      }

      const alert = ensurePreflightBlockedAlert();
      const issues = Array.isArray(validation.issues) ? validation.issues : [];
      const first = issues[0];
      if (!first) {
        hidePreflightBlockedAlert();
        return;
      }

      const issueCount = issues.length;
      const artworkIssues = Array.isArray(validation.artworkIssues) ? validation.artworkIssues : [];
      const authorizationMissing = Boolean(validation.authorizationMissing);
      const countLabel = issueCount === 1 && artworkIssues.length === 1 && !authorizationMissing
        ? '1 artwork issue'
        : issueCount === 1
          ? '1 item needs attention'
          : `${issueCount} items need attention`;

      let detail = '';
      if (authorizationMissing && artworkIssues.length) {
        if (artworkIssues.length === 1) {
          const onlyArtwork = artworkIssues[0];
          const placement = escapePreflightText(onlyArtwork.placement || 'Artwork');
          if (onlyArtwork.type === 'blocked') {
            const dpi = getPreflightDpi(onlyArtwork.placement);
            detail = Number.isFinite(dpi)
              ? `Artwork authorization is required, and ${placement} is <strong>${dpi} DPI</strong> (minimum <strong>150 DPI</strong>).`
              : `Artwork authorization is required, and ${placement} is below the <strong>150 DPI</strong> minimum.`;
          } else if (onlyArtwork.type === 'missing') {
            detail = `Artwork authorization is required, and ${placement} still needs artwork.`;
          } else {
            detail = `Artwork authorization is required, and ${placement} needs quality acknowledgment.`;
          }
        } else {
          detail = `Artwork authorization is required, and <strong>${artworkIssues.length}</strong> artwork placements need attention.`;
        }
      } else if (authorizationMissing) {
        detail = 'Artwork authorization is required before continuing.';
      } else {
        detail = artworkIssueDetail(first);
      }

      let actionLabel = 'Review issues';
      let actionKey = '__review__';
      if (issueCount === 1 && first.type === 'authorization') {
        actionLabel = 'Review authorization';
        actionKey = '__authorization__';
      } else if (issueCount === 1 && first.category === 'artwork') {
        const safePlacement = escapePreflightText(first.placement || 'Artwork');
        actionLabel = first.type === 'missing'
          ? `Add ${safePlacement} artwork`
          : first.type === 'acknowledgment'
            ? `Review ${safePlacement}`
            : `Fix ${safePlacement}`;
        actionKey = safePlacement;
      }

      alert.innerHTML = `
        <span class="me-studio-nav__preflight-icon" aria-hidden="true">!</span>
        <span class="me-studio-nav__preflight-copy">
          <strong>Can't continue yet — ${escapePreflightText(countLabel)}</strong>
          <span>${detail}</span>
        </span>
        <button type="button" data-me-preflight-go="${actionKey}">${actionLabel}</button>
      `;
      alert.hidden = false;
      preflightAlertShown = true;

      if (moveFocus) {
        try { alert.focus({ preventScroll: true }); } catch (_) { alert.focus(); }
      }

      /* Only auto-reveal a single issue. Multiple issues stay in the customer's
         current context until they choose Review issues. */
      if (issueCount === 1) revealPreflightIssue(first);
    };

    root.addEventListener('click', (event) => {
      const issueButton = event.target.closest?.('[data-me-preflight-go]');
      if (!issueButton) return;
      const action = issueButton.dataset.mePreflightGo || '';
      const validation = getStep3ValidationState();
      if (validation.ok) {
        hidePreflightBlockedAlert();
        return;
      }

      let issue = validation.issues[0];
      if (action === '__authorization__') {
        issue = validation.issues.find((item) => item.type === 'authorization') || issue;
      } else if (action !== '__review__') {
        issue = validation.issues.find((item) => item.placement === action) || issue;
      }
      revealPreflightIssue(issue, { focusIssue: true });
    });

    window.addEventListener('me:artwork-updated', () => {
      if (!preflightAlertShown) return;
      window.setTimeout(() => {
        const validation = getStep3ValidationState();
        if (validation.ok) hidePreflightBlockedAlert();
        else renderPreflightBlockedAlert(validation);
      }, 0);
    });

    rightsCheckbox?.addEventListener('change', () => {
      syncArtworkAuthorizationState();
      if (!preflightAlertShown) return;
      const validation = getStep3ValidationState();
      if (validation.ok) hidePreflightBlockedAlert();
      else renderPreflightBlockedAlert(validation);
    });

    syncArtworkAuthorizationState();

    /* =========================================================
       v15.4.7.7 — Step 4 price carryover + quantity gate
       The Step 4 summary now carries the complete configured per-shirt
       price (garment + paid placements) before any quantity is entered.
       The zero-quantity gate uses the same compact, accessible feedback
       pattern established for Step 3 instead of a buried inline message.
       ========================================================= */
    let quantityAlertShown = false;

    const ensureQuantityBlockedAlert = () => {
      let alert = nav.querySelector('[data-me-quantity-blocked-alert]');
      if (alert) return alert;
      alert = document.createElement('section');
      alert.className = 'me-studio-nav__preflight me-studio-nav__quantity-alert';
      alert.dataset.meQuantityBlockedAlert = '';
      alert.setAttribute('role', 'alert');
      alert.setAttribute('aria-live', 'assertive');
      alert.setAttribute('aria-atomic', 'true');
      alert.tabIndex = -1;
      alert.hidden = true;
      nav.prepend(alert);
      return alert;
    };

    const hideQuantityBlockedAlert = () => {
      const alert = nav.querySelector('[data-me-quantity-blocked-alert]');
      if (alert) alert.hidden = true;
      quantityAlertShown = false;
      const msg = root.querySelector('[data-me-size-message], [data-me-distribution-message]');
      msg?.classList.remove('is-required');
    };

    const focusFirstQuantityControl = () => {
      const target = root.querySelector('[data-me-size-distribution-grid] input[data-me-size-quantity], [data-me-size-quantity], [data-me-size-import-button]');
      if (!target) return;
      try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
    };

    const renderQuantityBlockedAlert = ({ moveFocus = false } = {}) => {
      const alert = ensureQuantityBlockedAlert();
      alert.innerHTML = `
        <span class="me-studio-nav__preflight-icon" aria-hidden="true">!</span>
        <span class="me-studio-nav__preflight-copy">
          <strong>Can't continue yet — quantity required</strong>
          <span>Enter at least one shirt quantity in any size before continuing.</span>
        </span>
        <button type="button" data-me-quantity-go>Choose a size</button>
      `;
      alert.hidden = false;
      quantityAlertShown = true;
      if (moveFocus) {
        try { alert.focus({ preventScroll: true }); } catch (_) { alert.focus(); }
      }
    };

    root.addEventListener('click', (event) => {
      if (!event.target.closest?.('[data-me-quantity-go]')) return;
      focusFirstQuantityControl();
    });

    const advance = () => {
      if (stage === 1) {
        const color = String(root.querySelector('[data-me-selected-color]')?.textContent || '').replace(/^Selected:\s*/i, '').trim();
        if (!color || color.toLowerCase() === 'select a color') {
          root.querySelector('[data-me-designer-colors] button,[data-me-designer-colors] [role="radio"],[data-me-designer-colors] input')?.focus();
          return;
        }
        go(2);
        return;
      }
      if (stage === 2) {
        const front = [...root.querySelectorAll('[data-me-placement-checkbox]')].some(input => input.type === 'radio' && input.checked);
        if (!front) {
          root.querySelector('[data-me-placement-checkbox][type="radio"]')?.focus();
          return;
        }
        runNativePrimary();
        window.setTimeout(() => { if (root.dataset.meCurrentStep === 'artwork') go(3); }, 80);
        return;
      }
      if (stage === 3) {
        const validation = getStep3ValidationState();
        if (validation.restoring) {
          syncArtworkRestoreState();
          return;
        }
        if (!validation.ok) {
          renderPreflightBlockedAlert(validation, { moveFocus: true });
          return;
        }
        hidePreflightBlockedAlert();
        runNativePrimary();
        window.setTimeout(() => { if (root.dataset.meCurrentStep === 'review') go(4); }, 100);
        return;
      }
      if (stage === 4) {
        if (sizeMissing()) {
          const msg = root.querySelector('[data-me-size-message], [data-me-distribution-message]');
          if (msg) {
            msg.textContent = 'Enter at least one size quantity to continue.';
            msg.classList.add('is-required');
          }
          renderQuantityBlockedAlert({ moveFocus: true });
          return;
        }
        hideQuantityBlockedAlert();
        go(5);
      }
    };

    next.addEventListener('click', advance);
    back.addEventListener('click', () => {
      if (stage === 3) { setCoreStep('design'); go(2); return; }
      if (stage === 4) { setCoreStep('artwork'); go(3); return; }
      go(stage - 1);
    });

    root.addEventListener('click', (event) => {
      const modeButton = event.target.closest?.('[data-me-order-mode]');
      if (!modeButton) return;
      const mode = modeButton.dataset.meOrderMode === 'multi' ? 'multi' : 'single';
      window.setTimeout(() => {
        const project = window.MomentsProject;
        if (project?.root === root && project.mode !== mode && typeof project.setMode === 'function') project.setMode(mode);
        root.querySelectorAll('[data-me-order-mode]').forEach((button) => {
          const active = button.dataset.meOrderMode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('aria-checked', String(active));
        });
      }, 0);
    }, true);

    root.addEventListener('input', (event) => {
      if (event.target.matches?.('[data-me-size-quantity]')) {
        const value = Math.max(0, parseInt(event.target.value || '0', 10) || 0);
        event.target.value = String(value);
        event.target.closest('.me-size-distribution__row')?.classList.toggle('has-quantity', value > 0);
        window.setTimeout(() => {
          syncQtyPricing();
          if (quantityAlertShown && !sizeMissing()) hideQuantityBlockedAlert();
        }, 0);
      }
    });
    root.addEventListener('change', (event) => {
      if (event.target.matches?.('[data-me-size-quantity],[data-me-placement-checkbox],[data-me-rights-checkbox]')) window.setTimeout(() => { syncQtyPricing(); syncPreviewTabs(); syncPrimary(); }, 0);

      /* v15.4.7.2: Keep the just-uploaded artwork card open.
         Quality/preflight feedback must be visible before the customer moves on.
         Customers can select the next placement manually after reviewing the result. */
      if (stage === 3 && event.target.matches?.('input[type="file"]')) {
        const fileInput = event.target;
        const currentCard = fileInput.closest?.('[data-me-location-artwork]');
        if (fileInput.files?.length && currentCard) {
          window.setTimeout(() => {
            currentCard.querySelector?.('.me-location-artwork__topline')?.click?.();
            currentCard.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
          }, 120);
        }
      }
    });
    window.addEventListener('me:designer-color-changed', () => window.setTimeout(() => { enrichSizeRows(); syncQtyPricing(); }, 80));
    window.addEventListener('me:neck-label-updated', () => window.setTimeout(() => { enrichSizeRows(); syncQtyPricing(); }, 0));

    nativePrimary?.addEventListener('click', (event) => {
      if (allowNativePrimary) return;
      if (stage === 5 && isQuoteRequired()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openBulkQuote();
        return;
      }
      if (stage === 5) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      advance();
    }, true);

    progress.addEventListener('click', (event) => {
      const b = event.target.closest('[data-me-studio-jump]');
      if (!b || b.disabled) return;
      const n = Number(b.dataset.meStudioJump);
      if (n < stage) go(n);
    });

    const openBtn = document.querySelector('[data-me-designer-open], [data-me-personalize-open], [data-me-open-designer]');
    openBtn?.addEventListener('click', () => { stage = 1; window.setTimeout(() => render({focus:false}), 0); });

    new MutationObserver(() => {
      if (root.classList.contains('is-open') && !root.dataset.meStudioRendered) {
        root.dataset.meStudioRendered = 'true';
        stage = 1;
        render({focus:false});
      }
      if (!root.classList.contains('is-open')) delete root.dataset.meStudioRendered;
    }).observe(root, {attributes:true, attributeFilter:['class']});

    render({focus:false});
  };

  const init = (scope=document) => {
    if (scope.matches?.('[data-me-designer]')) initRoot(scope);
    scope.querySelectorAll?.('[data-me-designer]').forEach(initRoot);
  };

  const boot = () => {
    init(document);
    let refreshTimer;
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) init(node);
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => init(document), 20);
    }).observe(document.documentElement, {childList:true, subtree:true});
    document.addEventListener('shopify:section:load', event => init(event.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();


/* v15.4.5.7 — keep Studio toolbar placement label synchronized with preview. */
(() => {
  const syncStudioPlacementHeading = (placement) => {
    if (!placement) return;
    document.querySelectorAll('[data-me-designer] [data-me-studio-preview-label], [data-me-designer] .me-designer__preview-toolbar h3').forEach((node) => {
      if (node && !node.matches('[data-me-preview-placement-label]')) node.textContent = placement;
    });
  };
  document.addEventListener('change', (event) => {
    const input = event.target?.closest?.('[data-me-placement-checkbox]');
    if (input?.checked) requestAnimationFrame(() => syncStudioPlacementHeading(input.value));
  });
  window.addEventListener('me:preview-placement', (event) => {
    const placement = event.detail?.placement || event.detail?.placementName;
    requestAnimationFrame(() => syncStudioPlacementHeading(placement));
  });
})();
